import HeaderBox from "@/components/HeaderBox";
import HelmetMetaData from "@/components/HelmetMetaData";
import { settingsNav } from "@/constants";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import { TbCategoryMinus, TbCategoryPlus } from "react-icons/tb";
import AnimatedPage from "@/components/AnimatedPage";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import ProfileDetails from "@/components/dashboard/settings-data/ProfileDetails";
import PaymentDetails from "@/components/dashboard/settings-data/PaymentDetails";
import ChangePassword from "@/components/dashboard/settings-data/ChangePassword";
import ChangePin from "@/components/dashboard/settings-data/ChangePin";

const Settings = () => {
  const [active, setActive] = useState("General");

  return (
    <AnimatedPage>
      <HelmetMetaData
        title="Account Settings | Billzpay"
        description="Quickly purchase airtime for your mobile phone with our easy-to-use platform. Stay connected with instant top-ups and secure transactions!"
      />

      <section className="p-3 sm:p-5">
        <div className="flex flex-col-reverse items-start justify-between md:flex-row">
          <HeaderBox
            title="Account Settings"
            subtext="Manage your personal information, privacy settings, and account preferences here."
          />

          <div>
            <h2 className="text-sm font-medium">
              <Link to="/dashboard" className="hover:underline">
                Dashboard
              </Link>

              <span className="px-2 text-xl font-thin">/</span>

              <span className="text-gray-400">Account Settings</span>
            </h2>
          </div>
        </div>

        <ScrollArea className="max-w-[600px] lg:max-w-none">
          <div className="flex w-max space-x-10 pb-3 pt-4 lg:space-x-12">
            {settingsNav.map((item, index) =>
              <div
                key={index}
                onClick={() => setActive(item.name)}
                className={cn(
                  "relative flex cursor-pointer items-center gap-2 font-medium text-gray-500 lg:pr-2",
                  {
                    "font-semibold text-black/85 dark:text-white":
                      active === item.name
                  }
                )}
              >
                <item.icon size={27} />
                <h3>
                  {item.name}
                </h3>

                {active === item.name &&
                  <motion.div
                    className="absolute -bottom-2 left-0 h-[2px] w-full rounded-full bg-primary"
                    layoutId="underline"
                  />}
              </div>
            )}
          </div>
          <ScrollBar orientation="horizontal" className="invisible" />
        </ScrollArea>

        <div className="pt-4 lg:pt-10">
          {active === "General" && <ProfileDetails />}
          {active === "Payment" && <PaymentDetails />}
          {active === "Change Password" && <ChangePassword />}
          {active === "Change Transaction Pin" && <ChangePin />}
        </div>
      </section>
    </AnimatedPage>
  );
};

export default Settings;
